import React from "react";

const PageNotFound = () => {
  return <div className="page-not-found">{/* <img src="404.png"/> */}</div>;
};

export default PageNotFound;
